import React from 'react';

function reset(form) {
    let inputs = form.querySelectorAll('input');
    
    inputs.forEach((i) => {
        if(i.name.endsWith('_hp')) {
            return
        }

        let text_types = [
            'text',
            'url',
            'email',
            'textarea',
            'date', 
            'time',
            'phone'
        ]

        if(text_types.includes(i.type)) {
            i.value = "";
        }
        else if (i.type === 'radio') {
            i.checked = false;
        }
        else if (i.type === 'checkbox') {
            i.checked = false;
        }
    });

    let textareas = form.querySelectorAll('textarea');
    textareas.forEach((i) => {
        i.value = "";
    })
}

const name = <>
    <label className="required">
        <span>Name</span>
        <input type="text" name="name" id="name" required autoComplete="name" />
    </label>
</>;

const email = <>
    <label className="required">
        <span>Your email address</span>
        <input type="email" name="email" id="email" required autoComplete="email" />
    </label>
</>;

const college = <>
    <fieldset>
        <legend>College</legend>
        <div className="compound">
            <label>
                <input type="radio" name="college" value="COA" />
                <span>College of Arts</span>
            </label>

            <label>
                <input type="radio" name="college" value="CBS" />
                <span>College of Biological Sciences</span>
            </label>

            <label>
                <input type="radio" name="college" value="CEPS" />
                <span>College of Engineering &amp; Physical Sciences</span>
            </label>

            <label>
                <input type="radio" name="college" value="CSAHS" />
                <span>College of Social &amp; Applied Human Sciences</span>
            </label>

            <label>
                <input type="radio" name="college" value="CBE" />
                <span>Gordon S. Lang School of Business and Economics</span>
            </label>

            <label>
                <input type="radio" name="college" value="OAC" />
                <span>Ontario Agriculture College</span>
            </label>

            <label>
                <input type="radio" name="college" value="OVC" />
                <span>Ontario Veterinary College</span>
            </label>

            <label>
                <input type="radio" name="college" value="Other" />
                <span>Other</span>
            </label>
        </div>
    </fieldset>
</>;

const status = <>
    <fieldset>
        <legend>Status</legend>
        <div className="compound">
            <label>
                <input type="radio" name="status" value="Undergraduate" />
                <span>Undergraduate</span>
            </label>

            <label>
                <input type="radio" name="status" value="Graduate" />
                <span>Graduate</span>
            </label>

            <label>
                <input type="radio" name="status" value="Faculty / Staff" />
                <span>Faculty / Staff</span>
            </label>

            <label>
                <input type="radio" name="status" value="Community" />
                <span>Community Member</span>
            </label>
        </div>
    </fieldset>
</>;

const course = <>
    <label>
        <span>Is this request associated with a course? What's the course code (e.g. GEOG 2030)?</span>
        <input type="text" name="course_code" id="course_code" />
    </label>
</>

const program = <>
    <label>
        <span>In what program / major are you registered, if any? (e.g. BSc Animal Biology; MA English, PhD Management)</span>
        <input type="text" name="program" id="program" />
    </label>
</>

export {
	reset,
    college,
    status, 
    name, 
    email,
    course,
    program
}